export const BURGER_BUTTON_TEST_ID = 'burger-button';
